var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivacyPolicy = function SvgPrivacyPolicy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#privacy_policy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.24 12.829-.05-1.338a1.983 1.983 0 0 0-3.964 0l-.05 1.338M1.495 14.301c.043-.73.55-1.246 1.278-1.304a31 31 0 0 1 2.434-.079c1.167 0 1.967.039 2.507.085.668.058 1.14.523 1.191 1.193.03.393.052.926.052 1.639s-.022 1.245-.052 1.638c-.05.67-.523 1.135-1.191 1.193-.54.047-1.34.085-2.507.085a30 30 0 0 1-2.506-.085c-.669-.058-1.14-.523-1.192-1.193a22 22 0 0 1-.052-1.638c0-.652.016-1.152.038-1.534M5.207 15.418v.833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.209 17.917c2.63 0 4.434-.135 5.557-.263a1.904 1.904 0 0 0 1.706-1.709c.134-1.204.277-3.225.277-6.362 0-1.198-.021-2.233-.055-3.122-.147-.408-.649-1.486-2.206-3.005-1.65-1.61-2.793-2.063-3.15-2.174a68 68 0 0 0-2.129-.032c-2.63 0-4.434.134-5.557.263a1.904 1.904 0 0 0-1.706 1.709c-.109.975-.223 2.487-.262 4.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 6.648c-.87.13-2.434.03-3.621-.08a1.94 1.94 0 0 1-1.762-1.754c-.112-1.167-.211-2.694-.076-3.537"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "privacy_policy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPrivacyPolicy;